import type {FontCategory} from '@Libraries/font-library';

import {SeasonName} from '@Libraries/seasons.library';

export interface TrySeasonalFontButtonProps {
  onClick: (selectedCategory: FontCategory) => void;
}

export const SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING: Record<string, number> = {
  [SeasonName.HALLOWEEN]: 9,
  [SeasonName.CHRISTMAS]: 10,
};

export const isSpecialSeasonFontCategory = (category: FontCategory): boolean => {
  return Object.values(SPECIAL_SEASON_NAME_TO_FONT_CATEGORY_ID_MAPPING).includes(category.idfontcategory);
};
